const bookingColumns = [
  {
    label: 'Booking ID',
    value: 'presentableId',
    textId: 'fleetadmin.booking.table.bookingid',
    disabled: true,
  },
  {
    label: 'Status',
    value: 'status',
    textId: 'fleetadmin.booking.table.status',
    disabled: false,
  },
  {
    label: 'Type',
    value: 'type',
    textId: 'fleetadmin.booking.table.type',
    disabled: false,
  },
  {
    label: 'Car Plate',
    value: 'confirmedCarId',
    textId: 'fleetadmin.booking.table.plate',
    disabled: false,
  },
  {
    label: 'From',
    value: 'from',
    textId: 'fleetadmin.booking.table.from',
    disabled: false,
  },
  {
    label: 'To',
    value: 'to',
    textId: 'fleetadmin.booking.table.to',
    disabled: false,
  },
  {
    label: 'Created at',
    value: 'created',
    textId: 'fleetadmin.booking.table.createdat',
    disabled: false,
  },
  {
    label: 'Category',
    value: 'categoryId',
    textId: 'fleetadmin.booking.table.category',
    disabled: false,
  },
  {
    label: 'Area',
    value: 'areaId',
    textId: 'fleetadmin.booking.table.area',
    disabled: false,
  },
];

export const defaultSelectedBookingColumns = bookingColumns.map(
  (bookingColumn) => bookingColumn.value
);

export default bookingColumns;
